<template>
  <el-dialog
    :title="$t('text.qr_code')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    @close="closeDialog()"
    width="500px"
    class="edit-group"
  >
    <div ref="print" id="print-box" class="text-center card-qr-code-wrapper">
      <div v-loading="loading" class="min-h-200">
        <div class="v-h-center mt-50">
          <div class="avatar v-h-center">{{ qrCodeLabel.split('')[0] }}</div>
        </div>
        <div class="mt-10">
          <span class="font-60 bold-font">{{ qrCodeLabel }}</span>
          <span v-if="roomNumber" class="secondary-font ml-20 font-40">{{
            roomNumber
          }}</span>
        </div>
        <div class="font-30">{{ $t('text.smartz_observations') }}</div>
        <img
          :src="qrCodeSrcPrefix + qrCodeSrc"
          v-if="qrCodeSrc"
          class="w-180 mt-10"
        />
        <div class="bottom-area">
          {{
            $t('text.patient', {
              patient: $store.state.locale.patient
            }).toUpperCase()
          }}
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="save-btn min-w-80"
        @click="print()"
        :disabled="!qrCodeSrc"
        >{{ $t('text.print') }}</el-button
      >
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import printJS from 'print-js'
import html2canvas from 'html2canvas'
import swal from 'sweetalert'
export default {
  data() {
    return {
      dialogVisible: false,
      qrCodeSrcPrefix: 'data:image/png;base64,',
      loading: false,
      qrCodeSrc: '',
      qrCodeLabel: '',
      roomNumber: '',
      helpQrCodeSrc: ''
    }
  },
  methods: {
    openDialog(id, isOrganization) {
      this.dialogVisible = true
      this.getQRCode(id, isOrganization)
    },
    closeDialog() {
      this.qrCodeSrc = ''
      this.qrCodeLabel = ''
      this.roomNumber = ''
      this.dialogVisible = false
    },
    getQRCode(id, isOrganization) {
      this.loading = true
      let request = isOrganization
        ? ApiService.GetQRForOrganisation(
            id,
            this.$store.state.locale.currentLocale
          )
        : ApiService.GetQRForPatient(id, this.$store.state.locale.currentLocale)
      request
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.qrCodeSrc = response.data.data.observationqr || null
            this.qrCodeLabel = isOrganization
              ? response.data.data.name || null
              : response.data.data.alias || null
            this.roomNumber = isOrganization
              ? ''
              : response.data.data.roomNumber
            this.helpQrCodeSrc = response.data.data.helpqr || null
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: 'Failed',
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    print() {
      window.pageYoffset = 0
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      let options = {
        backgroundColor: null,
        dpi: window.devicePixelRatio * 2,
        scale: 2,
        removeContainer: false
      }
      html2canvas(this.$refs.print, options).then(canvas => {
        const url = canvas.toDataURL()
        printJS({
          printable: url,
          type: 'image',
          scanStyles: false,
          style:
            'body { text-align: center } img {width: 2.125in; height: 3.375in}'
        })
      })
    }
  }
}
</script>

<style lang="scss">
#print-box {
  img {
    margin: 0 auto;
  }
}
.card-qr-code-wrapper {
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
  .avatar {
    width: 80px;
    height: 80px;
    border-radius: 40px;
    background-color: #ccc;
    color: white;
    font-weight: bold;
    font-size: 40px;
  }
  .bottom-area {
    background-color: #253a5d;
    color: white;
    font-weight: bold;
    font-size: 60px;
    padding: 20px 0;
    margin-top: 30px;
  }
}
</style>
